var url_domain = window.location.host;
var config_url = "";
if (url_domain == "localhost:8080" || url_domain == "localhost:8081") {
  //config_url = "https://apitest2.ccdfvf.com/api/1.0";
  config_url = "http://localhost:3333/api/1.0";
  // config_url = "https://api.ccdfvf.com/api/1.0";

} else if (url_domain == "test.ccdfvf.com") {
  config_url = "https://apitest2.ccdfvf.com/api/1.0";
} else if (url_domain == "campusccd.fvf.com.ve") {
  config_url = "https://api.ccdfvf.com/api/1.0";
} else {
  // Si no coincide con ningún caso, usar la URL de prueba por defecto
  config_url = "https://apitest.ccdfvf.com/api/1.0";
  console.log("Domain not recognized, using test API by default");
}

console.log("Backend Connected: " + config_url);
export const apiPath = config_url;
